export enum ShopDineRelaxCategory {
	Eat = 'eat',
	Shop = 'shop',
	Relax = 'relax',
}
